export const roundedCount = count => {
  if (count > 99) return "99+";

  return count;
};
